import { respondTo } from "@/respondTo";
import { Box, styled } from "@mui/material";

export const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-start",
  zIndex: 1,
  width: "100%",
  color: theme.palette.common.corporateColors.primary.white,
  backgroundImage: "url(/assets/contact/main/contactMain.webp)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "60% 0",
  backgroundColor: theme.palette.common.corporateColors.primary.midNightBlue,
  [theme.breakpoints.up("md")]: {
    backgroundPosition: "100% 0",
  },
  [theme.breakpoints.up("lg")]: {
    backgroundPosition: "initial",
  },
}));

export const ImgBox = styled("div")(
  ({ theme }) => `
  object-fit: cover;
  width: 26.92rem;
  height: 100%;
  position: relative;

  ${respondTo.tablet_landscape_s`
        width: 35.43rem;
        height: 100%;
    `}

  ${respondTo.desktop_xl`
        width: 49.5rem
         height: 100%;
    `}
`
);
